// extracted by mini-css-extract-plugin
export default {"component":"CodeInput_component__URz94","input":"CodeInput_input__cWeFo"};